import React, { useEffect, useState } from "react";
import API from "../api/axios";
import DashboardLayout from "../layout/DashboardLayout";
import "./Trips.css";

const Bilty = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const [bilties, setBilties] = useState([]);
  const token = localStorage.getItem("token");

  const filteredBilties = bilties.filter((b) => {
    const search = searchTerm.trim().toLowerCase();
    if (!search) return true;

    const biltyNumber = b.biltyNumber?.toLowerCase() || "";
    const origin = b.origin?.toLowerCase() || "";
    const destination = b.destination?.toLowerCase() || "";
    const consignor = b.consignor?.toLowerCase() || "";
    const consignee = b.consignee?.toLowerCase() || "";

    return (
      biltyNumber.includes(search) ||
      origin.includes(search) ||
      destination.includes(search) ||
      consignor.includes(search) ||
      consignee.includes(search)
    );
  });

  useEffect(() => {
    const loadBilties = async () => {
      try {
        const res = await API.get("/bilties/all", {
          headers: { Authorization: `Bearer ${token}` }
        });
        setBilties(res.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    loadBilties();
  }, [token]);


  const generatePDF = async (id) => {
    try {
      const res = await API.get(`/bilties/pdf/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob"
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `bilty-${id}.pdf`);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <DashboardLayout>
      <div className="trip-page">

        <div className="trip-search-bar">
          <input
            type="text"
            placeholder="Search by Bilty No, From, To, Consignor, Consignee"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <h2>Bilties</h2>
        <div className="trip-table">
          <table>
            <thead>
              <tr>
                <th>Bilty Number</th>
                <th>Trip</th>
                <th>Consignor</th>
                <th>Consignee</th>
                <th>Freight</th>
                <th>Advance</th>
                <th>Balance</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredBilties.length === 0 && <tr><td colSpan={8}>No Bilties Found</td></tr>}
              {filteredBilties.map(b => (
                <tr key={b._id}>
                  <td>{b.biltyNumber}</td>
                  <td>{b.origin} → {b.destination}</td>
                  <td>{b.consignor}</td>
                  <td>{b.consignee}</td>
                  <td>{b.freight}</td>
                  <td>{b.advance}</td>
                  <td>{b.balance}</td>
                  <td>
                    <button onClick={() => generatePDF(b._id)}>PDF</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Bilty;
